import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import AddToCalendarCustomButton from "src/components/Button/AddToCalendarCustomButton";

const AddToCalendarBanner = ({
  bgImage,
  text,
  gradientStart = "rgba(139, 0, 0, 1)",
  gradientEnd = "rgba(200, 50, 50, 1)",
  innerBgColor = "#651b38",
  bgPosition = "center top",
  bgAttachment = "fixed",
  overlayOpacity = 0.7,
  name,
  description,
  location,
  startDate,
  endDate,
  startTime,
  endTime,
  timeZone = "America/New_York",
}) => {
  return (
    <BannerWrapper gradientStart={gradientStart} gradientEnd={gradientEnd} bgPosition={bgPosition} bgAttachment={bgAttachment} innerBgColor={innerBgColor} overlayOpacity={overlayOpacity}>
      <div
        className="inner"
        style={{
          backgroundImage: bgImage ? `url(${bgImage})` : undefined,
        }}
      >
        {text && (
          <div className="banner-text">
            <ReactMarkdown>{text}</ReactMarkdown>
          </div>
        )}
        <div className="add-to-calendar-wrapper">
          <AddToCalendarCustomButton
            name={name}
            description={description}
            location={location}
            startDate={startDate}
            endDate={endDate}
            startTime={startTime}
            endTime={endTime}
            timeZone={timeZone}
          />
        </div>
      </div>
    </BannerWrapper>
  );
};

const BannerWrapper = styled.div`
  background: ${(props) => props.gradientStart};
  background: linear-gradient(
    0deg,
    ${(props) => props.gradientStart} 0%,
    ${(props) => props.gradientEnd} 100%
  );
  padding: 1px;
  margin-bottom: 2rem;

  .inner {
    position: relative;
    background-position: ${(props) => props.bgPosition};
    background-repeat: no-repeat;
    background-attachment: ${(props) => props.bgAttachment};
    background-size: cover;
    color: var(--white);
    padding: 1.5rem 1.5rem 1rem;
    text-align: center;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background-color: ${(props) => props.innerBgColor};
      opacity: ${(props) => props.overlayOpacity};
      pointer-events: none;
      z-index: 0;
    }
  }

  .banner-text {
    position: relative;
    z-index: 1;
  }

  .add-to-calendar-wrapper {
    position: relative;
    z-index: 3;
  }

  .banner-text {
    p {
      color: var(--white);
      font-size: 1.1rem;
      margin: 0 0 0.5rem;
    }
    strong {
      color: var(--white);
    }
  }
`;

export default AddToCalendarBanner;
